var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationProprietaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_333",
    "data-name": "Ellipse 333",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "#ff6f08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationProprietaire);
export default __webpack_public_path__ + "static/media/InformationProprietaire.d3cfdf9c6d65fe171d04b72036beedbe.svg";
export { ForwardRef as ReactComponent };